module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Calisto MT",
      "font-size": "18pt",
      "letter-spacing": "1px",
      "padding-top": "80px",
      "padding-bottom": "20px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("This is Stephen Morris’ second novel. His first, "), _c('em', [_vm._v("Memoir,")]), _vm._v(" "), _c('em', [_vm._v("A Novel by Stella Kelly")]), _vm._v(", was published by Austin Macauley in 2019.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0235a5e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0